export const updateProject = (id, data) =>
    fetch(`/api/v1/tracking-projects/${id}/`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });

export const deleteProject = (id) =>
    fetch(`/api/v1/tracking-projects/${id}/`, {
        method: 'Delete',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });

export const checkDomains = (domains) =>
    fetch('/api/v1/domains/validate-accessibility/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify({ domains }),
    });

export const disableProject = (id) =>
    fetch(`/api/v1/tracking-projects/${id}/disable/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });

export const enableProject = (id) =>
    fetch(`/api/v1/tracking-projects/${id}/enable/`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
